import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { PaymentType } from '__generated__/api';

export const getPaymentTypeInput = (searchCriteria: SearchCriteriaModel): PaymentType[] | null => {
  if (searchCriteria.paymentType && searchCriteria.paymentType.length > 0) {
    return searchCriteria.paymentType
      .map(type => {
        const result = PaymentType[PaymentType[type]];

        return result ? result : null;
      })
      .filter(type => type !== null);
  }

  return null;
};
